import { Button as ChakraButton, ButtonProps } from '@chakra-ui/react';

interface CustomButtonProps extends ButtonProps {
  visual?: 'solid' | 'subtle' | 'ghost';
}

export const CustomButton = ({ visual, ...props }: CustomButtonProps) => {
  return <ChakraButton {...(props as any)} visual={visual} />;
}; 